var map = {
	"./api_psd2_bank_reader.svg": "f226",
	"./api_psd2_pagos.svg": "4779",
	"./api_utilities.svg": "dc6d",
	"./empresas_bancos_unidos.svg": "bbec",
	"./empresas_pago_por_link.svg": "4611",
	"./empresas_pasarela_de_pagos.svg": "0fe9",
	"./empresas_scoring_prestamos.svg": "9caa",
	"./particulares_bancos_unidos.svg": "1dcd",
	"./particulares_pago_por_link.svg": "cee3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e77";